import { useEffect, useRef, useState } from "react";
import ClientInformation from "../ClientInformation";

const RadiographyReport = () => {
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRef2 = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  useEffect(() => {
    adjustHeight2();
  }, [value2]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const adjustHeight2 = () => {
    if (textareaRef2.current) {
      textareaRef2.current.style.height = "auto";
      textareaRef2.current.style.height = `${textareaRef2.current.scrollHeight}px`;
    }
  };

  return (
    <div>
      <div>
        <ClientInformation />
      </div>

      {/* FINDINGS SECTION */}
      <div className="gap-2 flex flex-col">
        <p className=" font-semibold border-gray-500 underline">FINDINGS:</p>
        <div className="w-full">
          {/* Show textarea in normal view */}
          <textarea
            ref={textareaRef}
            className="w-full border p-4 text-sm resize-none print:hidden"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onInput={adjustHeight}
          />
          {/* Show div when printing */}
          <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
        </div>
      </div>

      {/* INTERPRETATION / COMMENTS SECTION */}
      <div className="gap-2 flex w-full pt-3 flex-col">
        <p className=" font-semibold border-gray-500 underline">INTERPRETATION/COMMENTS:</p>
        <div className="w-full">
          {/* Show textarea in normal view */}
          <textarea
            ref={textareaRef2}
            className="w-full border p-4 text-sm resize-none print:hidden"
            value={value2}
            onChange={(e) => setValue2(e.target.value)}
            onInput={adjustHeight2}
          />
          {/* Show div when printing */}
          <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value2}</div>
        </div>
      </div>

      <div className="gap-2 flex items-center w-full pt-3">
        <p className="text-sm">Doctor's Name</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default RadiographyReport;
